import { useState } from "react"
import { Button } from "@/components/ui/button"
import { ChevronDown, ChevronUp } from "lucide-react"
import ProgressBar from "@/components/ui/custom/custom-progress-bar"

type TechExperienceDetail = {
  skill: string
  experience: number
}

type TechExperienceCardProps = {
  techExperience?: TechExperienceDetail[]
}

const roundToNearestHalf = (value: number): number => {
  return Math.round(value * 2) / 2
}

const calculateProgressPercentage = (years: number): number => {
  return Math.min((years / 5) * 100, 100)
}

// Mock data to use as fallback
const mockTechExperience: TechExperienceDetail[] = [
  { skill: "JavaScript", experience: 3 },
  { skill: "React", experience: 2 },
  { skill: "Node.js", experience: 1.5 },
]

export default function TechExperienceCard({ techExperience = mockTechExperience }: TechExperienceCardProps) {
  const [showAll, setShowAll] = useState(false)

  // Ensure we always have an array to map over
  const experienceData = techExperience.length > 0 ? techExperience : mockTechExperience

  // Sort by experience (highest first) and limit to 3 if not showing all
  const sortedExperience = [...experienceData].sort((a, b) => b.experience - a.experience)
  const displayedExperience = showAll ? sortedExperience : sortedExperience.slice(0, 3)

  return (
    <div className="space-y-4">
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {displayedExperience.map((tech, index) => (
          <div key={index} className="p-4 border rounded-lg shadow-sm">
            <div className="flex justify-between mb-2">
              <span className="font-medium">{tech.skill}</span>
              <span className="text-muted-foreground">approx {roundToNearestHalf(tech.experience)} years</span>
            </div>
              <ProgressBar value={calculateProgressPercentage(tech.experience)} className='h-3' max={100} />
          </div>
        ))}
      </div>

      {experienceData.length > 3 && (
        <div className="flex justify-center mt-4">
          <Button variant="outline" size="sm" onClick={() => setShowAll(!showAll)} className="flex items-center gap-1">
            {showAll ? (
              <>
                <ChevronUp className="h-4 w-4" />
                Show less
              </>
            ) : (
              <>
                <ChevronDown className="h-4 w-4" />
                Show {experienceData.length - 3} more skills
              </>
            )}
          </Button>
        </div>
      )}
    </div>
  )
}



